module.exports = "/_next/static/images/af9830babbfc19ef517b871ea035b5e6-nubank-shooting-hands-diversity@0.5x.jpg";